import { useSelector } from 'react-redux';

import GeneralContent from './carrots/GeneralContent';
import ProductUpsell from './carrots/ProductUpsell';

const Carrots = (props) => {
  const { location } = props;

  const cart = useSelector((state) => state.cart.data);

  const carrot = cart?.carrots?.[location];

  if (!carrot || !location) {
    return null;
  }

  if (carrot.type === 'General Content') {
    return <GeneralContent carrot={carrot} />;
  }

  return <ProductUpsell carrot={carrot} />;
};

export default Carrots;
